import React from "react";

export const PawIcon = ({ size = 24, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    <ellipse cx="7" cy="7" rx="2" ry="2.6" />
    <ellipse cx="12" cy="5.2" rx="2" ry="2.6" />
    <ellipse cx="17" cy="7" rx="2" ry="2.6" />
    <ellipse cx="4.5" cy="11.5" rx="1.7" ry="2.1" />
    <ellipse cx="19.5" cy="11.5" rx="1.7" ry="2.1" />
    <path d="M12 10c-3.2 0-6 2.4-6 5.2 0 2.2 1.6 3.8 3.8 3.8 1.1 0 1.6-.5 2.2-.5s1.1.5 2.2.5c2.2 0 3.8-1.6 3.8-3.8C18 12.4 15.2 10 12 10z" />
  </svg>
);

export const HeartIcon = ({ size = 22, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 11c0 5.65-7 10-7 10z" />
  </svg>
);

export const BoneIcon = ({ size = 22, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M5 7a2.5 2.5 0 1 1 3-2 2.5 2.5 0 0 1 3 2v1l4 4v-1a2.5 2.5 0 1 1 3 2 2.5 2.5 0 0 1-3 2v-1l-4-4v1a2.5 2.5 0 1 1-3 2 2.5 2.5 0 0 1-3-2V7z" opacity=".95" />
  </svg>
);

export const HouseIcon = ({ size = 26, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M3 11.5 12 4l9 7.5" />
    <path d="M5 10v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9" />
    <path d="M10 20v-5h4v5" />
  </svg>
);

export const CatIcon = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M4 4l3 4h10l3-4v9a8 8 0 0 1-16 0V4z" />
    <circle cx="9" cy="12" r="1" fill="#fffaf7" />
    <circle cx="15" cy="12" r="1" fill="#fffaf7" />
    <path d="M11 15.5h2l-1 1z" fill="#fffaf7" />
  </svg>
);

export const DogIcon = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M5 6c0-2 2-3 3-2l2 2h4l2-2c1-1 3 0 3 2v3l2 1v3l-2 1v5a1 1 0 0 1-1 1h-2v-3h-8v3H6a1 1 0 0 1-1-1v-5l-2-1v-3l2-1V6z" />
    <circle cx="10" cy="11" r=".9" fill="#fffaf7" />
    <circle cx="14" cy="11" r=".9" fill="#fffaf7" />
  </svg>
);

export const StarIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 2l2.9 6.6 7.1.7-5.4 4.9 1.6 7-6.2-3.7L5.8 21l1.6-7L2 9.3l7.1-.7L12 2z" />
  </svg>
);

export const InstagramIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
);

export const FacebookIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M13 22v-8h3l.5-4H13V7.5c0-1.2.3-2 2-2H17V2.1c-.4 0-1.6-.1-3-.1-3 0-5 1.8-5 5.2V10H6v4h3v8h4z" />
  </svg>
);

/* Decorative scattered paws */
export const PawScatter = ({ className = "", count = 8 }) => {
  const seed = [
    { top: "8%", left: "5%", size: 22, rot: -15, op: 0.18 },
    { top: "18%", left: "82%", size: 28, rot: 22, op: 0.16 },
    { top: "62%", left: "10%", size: 26, rot: 8, op: 0.14 },
    { top: "70%", left: "75%", size: 20, rot: -20, op: 0.18 },
    { top: "35%", left: "45%", size: 18, rot: 14, op: 0.12 },
    { top: "85%", left: "40%", size: 22, rot: -8, op: 0.14 },
    { top: "45%", left: "92%", size: 18, rot: 24, op: 0.16 },
    { top: "92%", left: "18%", size: 18, rot: -12, op: 0.14 },
  ].slice(0, count);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {seed.map((p, i) => (
        <PawIcon
          key={i}
          size={p.size}
          style={{
            position: "absolute",
            top: p.top,
            left: p.left,
            transform: `rotate(${p.rot}deg)`,
            color: "#6b3f2a",
            opacity: p.op,
          }}
        />
      ))}
    </div>
  );
};
